import { create } from 'zustand';
import {
  SimpleVenueData,
  VenueData,
  VenueFilterData,
  VenueTagData,
} from '../dto/EntityRepository';
import type { ResourceStatus } from '../util/scopedResource';
import { getDefaultVenueFilterData } from '../util/venueListParams';

interface ExhibitionVenueState {
  venueList: SimpleVenueData[];
  activeVenue: VenueData | null;
  selectedVenueId: string | null;
  filterData: VenueFilterData;
  tags: VenueTagData[];
  detailStatus: ResourceStatus;
  setVenueList: (venueList: SimpleVenueData[]) => void;
  setActiveVenue: (activeVenue: VenueData | null) => void;
  setSelectedVenueId: (selectedVenueId: string | null) => void;
  setFilterData: (filterData: VenueFilterData) => void;
  setTags: (tags: VenueTagData[]) => void;
  setDetailStatus: (status: ResourceStatus) => void;
  clearActiveVenue: () => void;
}

export const useExhibitionVenueStore = create<ExhibitionVenueState>((set) => ({
  venueList: [],
  activeVenue: null,
  selectedVenueId: null,
  filterData: getDefaultVenueFilterData(),
  tags: [],
  detailStatus: 'idle',
  setVenueList: (venueList) => set({ venueList }),
  setActiveVenue: (activeVenue) => set({ activeVenue, detailStatus: 'success' }),
  setSelectedVenueId: (selectedVenueId) => set({ selectedVenueId }),
  setFilterData: (filterData) => set({ filterData }),
  setTags: (tags) => set({ tags }),
  setDetailStatus: (detailStatus) => set({ detailStatus }),
  clearActiveVenue: () => set({ activeVenue: null, selectedVenueId: null, detailStatus: 'idle' }),
}));
